var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBadgeVisible)?_c('div',{class:_vm.inline ? 'valueChangedBadgeInline' : 'valueChangedBadge',style:(_vm.inlineStyle())}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }